import StandingsModel from '../models/StandingsModel';

export default {
    model: StandingsModel,
    namespace: 'standings',
    expires: 600,
    pathTemplate: 'api/v1/standings?leagueId={leagueIds}&season={season}&date={gameDate}&hydrate=division'
};